import React, { useEffect, useState, useContext } from 'react';
import { View, TextInput, Pressable } from 'react-native';
import { useLazyQuery } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import UserContext from '../../contexts/UserContext';
import { createPortal } from 'react-dom';

import { useNavigate } from 'app/src/utils/routing';
import { Text } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

import { SEARCH } from './queries';
import Result from './Result';

const Container = styled(View)`
  flex: 1;
  flex-direction: row;
  background-color: white;
  align-self: ${props => props.screenWidth < 600 ? 'left' : 'center'};
  align-items: center;
  height: 32px;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 12px;
  margin-left: ${props => props.screenWidth < 600 ? '20px' : '80px'};
  margin-right: ${props => props.screenWidth < 600 ? '20px' : '40px'};
  border-width: 2px;
  border-style: solid;
  border-color: black;
  max-width: 600px;
`;

const Input = styled(TextInput)`
  outline-width: 0px;
  outline-color: white;
  flex: 1
  margin-left: 12px;
`;

const Results = styled(View)`
  position: absolute;
  top: ${props => props.screenWidth < 600 ? '120px' : props.screenWidth < 992 ? '60px' : '60px'};
  left: ${props => props.screenWidth < 600 ? '0px' : props.screenWidth < 992 ? '160px' : '242px'};
  background-color: white;
  border-width: 1px;
  border-style: solid;
  border-color: black;
  padding-top: 5px;
`;

const Search = () => {
  const { screenWidth } = useContext(UserContext);
  const [term, setTerm] = useState('');
  const [selectedIndex, setSelectedIndex] = useState();
  const navigate = useNavigate();
  const [getResults, { data }] = useLazyQuery(SEARCH);

  useEffect(() => {
    if (term && term.length > 2) {
      getResults({ variables: { term }});
    }
  }, [term]);

  useEffect(() => {
    const handleKeyUp = (e) => {
      if (!data?.search) {
        return;
      }

      if (!data || 0 === data.search.length) {
        setSelectedIndex(undefined);
      }

      let newIndex = selectedIndex;
      if ('undefined' === typeof newIndex) {
        newIndex = -1;
      }

      if (e.keyCode === 13) { // Enter
        if ('undefined' === typeof selectedIndex) {
          return false;
        }

        const result = data.search[selectedIndex];
        const typename = result.__typename;

        setTerm('');
        if ('Asset' === typename) {
          navigate(`/sellers/${result.seller.id}/assets/${result.id}`);
        } else if ('Buyer' === typename) {
          navigate(`/buyers/${result.id}`);
        } else if ('BuyerUser' === typename) {
          navigate(`/buyers/${result.buyer.id}`);
        } else if ('BuyerSale' === typename) {
          navigate(`/buyers/${result.buyer.id}`);
        } else if ('SaleAsset' === typename) {
          navigate(`/sellers/${asset.seller.id}/assets/${asset.id}`);
        } else if ('Sale' === typename) {
          navigate(`/sales/${result.id}`);
        } else if ('Seller' === typename) {
          navigate(`/sellers/${result.id}`);
        } else if ('Vendor' === typename) {
          navigate(`/vendors/${result.id}`);
        }
      } else if (38 === e.keyCode) { // Up
        newIndex = newIndex - 1;
      } else if (40 === e.keyCode) { // Down
        newIndex = newIndex + 1;
      } else {
        setSelectedIndex(undefined);
        return;
      }

      if (newIndex < 0) {
        setSelectedIndex(0);
      } else if (newIndex >= data.search.length) {
        setSelectedIndex(data.search.length - 1);
      } else {
        setSelectedIndex(newIndex);
      }
    }

    window.document.addEventListener('keyup', handleKeyUp);

    return () => {
      window.document.removeEventListener('keyup', handleKeyUp);
    }
  }, [data, selectedIndex]);

  return (
    <Container screenWidth={screenWidth}>
      {term ? (
        <Pressable onPress={() => setTerm('')}>
          <FontAwesomeIcon
            icon={faXmark}
            color={colors.disabled}
          />
        </Pressable>
      ) : (
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          color={colors.disabled}
        />
      )}
      <Input
        placeholder="Search"
        placeholderTextColor={colors.disabled}
        value={term}
        onChange={e => setTerm(e.target.value)}
      />
      {data && term.length > 2 && data.search.length > 0 && (
        createPortal(
          <Results screenWidth={screenWidth}>
            {data.search.map((result, index) => (
              <Result
                key={`${result.__typename}-${result.id}`}
                result={result}
                setTerm={setTerm}
                selected={index === selectedIndex}
              />
            ))}
          </Results>, document.body
        )
      )}
    </Container>
  );
};

export default Search;
